import { GeneralCard, TableCard } from "@ui/internal/components/card";
import { endpoint } from "@services/api.services";
import FilterPopover from "@ui/internal/components/filter-popover";
import { formatDate } from "@utils/helper/index.helper";
import { usePathname } from "@utils/hook/index.hook";
import { useListData } from "@utils/query/index.query";
import { useMetaStore } from "@utils/states/index.state";
import { useSearchParams } from "react-router";
import { ColumnList } from "./column/index.column";
import SuccessForm from "./form/success.form";
import { QueryData } from "@utils/interface/index.interface";
import { SuccessStoryData } from "@utils/interface/journey.interface";
import { useEffect } from "react";
const index = () => {
  const pathname = usePathname();

  const { search, date } = useMetaStore();
  const [searchParams, setSearchParams] = useSearchParams();
  const { data, refetch, isPending, error } = useListData<
    QueryData<SuccessStoryData>
  >({
    endpoint: endpoint["successstory"],
    key: `${pathname}-listing`,
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      search,
      created_date__gte: date.from ? formatDate(date.from) : "",
      created_date__lte: date.to ? formatDate(date.to) : "",
      ordering: searchParams.get("ordering") || "order",
      team_member__id__in: searchParams.get("success-story-team-members") || "",
      student__id__in: searchParams.get("success-story-studnet") || "",
    },
  });
  // rollback page
  useEffect(() => {
    if (error?.status === 404 && error?.data?.detail === "Invalid page.") {
      searchParams.set("tpage", "1");
      setSearchParams(searchParams);
    }
  }, [error]);

  const columns = ColumnList({ refetch });
  return (
    <>
      <TableCard
        bulkActions
        table_content={{
          mode: "default",
          type: pathname,
        }}
        isPending={isPending}
        formId={pathname}
        inject_ui_table_actions={
          <FilterPopover
            filters={[
              {
                label: "Team Member",
                endpointValue: "success-story-team-members",
                format: { key: "name", value: "id" },
              },

              {
                label: "Student",
                endpointValue: "success-story-studnet",
                format: { key: "name", value: "id" },
              },
            ]}
            title="Filter"
            triggerText="Filter"
          />
        }
        showOrientationSecond
        sortableFilter={{
          search: search,
          ordering: searchParams.get("ordering") || "order",
          team_member__id__in:
            searchParams.get("success-story-team-members") || "",
          student__id__in: searchParams.get("success-story-studnet") || "",
        }}
        tableHeaderData={<>Showing all datas for Success Stories</>}
        grid={
          <GeneralCard
            isChecked={false}
            showCheck
            type={"success-stories"}
            onDelete={() => {}}
            onEdit={() => {}}
          />
        }
        columns={columns}
        endpoint={endpoint["successstory"]}
        refetch={refetch}
        rows={data?.data?.results ?? []}
        count={data?.data?.count ?? 10}
        form={<SuccessForm />}
      />
    </>
  );
};

export default index;
